export const RmCountPriceListColumns = [
    "SNo",
    // "MinValue",
    // "MaxValue", 
    "Price",
    "Count", 
    "Company",
    "Type"
]